import * as angular from 'angular';
import * as moment from 'moment';
import { DppExportCsvService } from '../../services/dpp-export-csv.service';

export class BaseAnalytics {
  public to: Date;
  public from: Date;
  public toDateOptions: any;
  public fromDateOptions: any;
  public waiting = false;
  protected exportHeaders: string[];

  constructor(
    protected dppExportCsvService: DppExportCsvService,
    protected translate: angular.translate.ITranslateService
  ) {
    this.to = new Date();
    this.from = new Date(this.to.getFullYear(), this.to.getMonth(), 1);
    this.toDateOptions = {
      formatYear: 'yyyy',
      startingDay: 0,
      minDate: this.from
    };
    this.fromDateOptions = {
      formatYear: 'yyyy',
      startingDay: 0,
      maxDate: this.to
    };
  }

  public async onChangeDate() {
    this.fromDateOptions.maxDate = this.to;
    this.toDateOptions.minDate = this.from;
    this.loadReports();
  }

  protected loadReports() {
  }

  protected export(items: any[], prefix: string) {
    if (items) {
      const locations = angular.copy(items);
      const rows: string[][] = [this.exportHeaders];
      for (const location of locations) {
        rows.push((Object as any).values(location));
      }
      const from = moment(this.from).format('DD_MM_YYYY');
      const to = moment(this.to).format('DD_MM_YYYY');
      const fileName = `${prefix} ${from} - ${to}`;
      this.dppExportCsvService.exportToCsv(rows, fileName);
    }
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/models/dpp-analytics/base-analytics.ts